import { EntityModules, LIBRARY_ENTITY_MODULES, UserRole } from 'core/constants';
import SessionUser from 'stores/Session/SessionUser';

import { canArchiveLibrary } from 'utils/roles/permissions';

// Hides the menu item only; core-api's ManagerOnlyEntityDeletePermission is the boundary. The
// UI-side and API-side sets deliberately differ; do not reconcile them here.
const DELETE_RESTRICTED_TO_MANAGERS = new Set([EntityModules.Events, EntityModules.Risks]);

// Read by both the register's row menu and the record header, so the two cannot drift apart.
export const canDeleteEntity = (type: EntityModules, user?: SessionUser | null): boolean =>
  !(DELETE_RESTRICTED_TO_MANAGERS.has(type) && user?.role === UserRole.User) && !user?.readOnly;

export const canDeleteFromRecord = (type: EntityModules, user?: SessionUser | null): boolean =>
  LIBRARY_ENTITY_MODULES.includes(type)
    ? canArchiveLibrary(user ?? null) && !user?.readOnly
    : canDeleteEntity(type, user);
